(function () {
  'use strict';

  angular.module('web2print').factory('Browser', Browser);

  Browser.inject = ['$window'];

  function Browser ($window) {

    const userAgent = $window.navigator.userAgent;
    // Regexp pattern to test upon
    const browsers = {
      chrome: /chrome/i, safari: /safari/i,
      firefox: /firefox/i, ie: /internet explorer/i
    };

    const browserID = { id: 'unknown' };
    for (const key in browsers)
      if (browsers[key].test(userAgent))
        browserID.id = key;

    const service = {
      checkIEVersion: checkIEVersion,
      isIE: function () { return browserID.id === 'ie'; },
      isChrome: function () { return browserID.id === 'chrome'; },
      isSafari: function () { return browserID.id === 'safari'; },
      isFirefox: function () { return browserID.id === 'firefox'; }
    };

    return service;

    function checkIEVersion () {
      const sAgent = $window.navigator.userAgent;
      const Idx = sAgent.indexOf('MSIE');

      // If IE, return version number.
      if (Idx > 0) {
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
      }

      // If IE 11 then look for Updated user agent string.
      else if (sAgent.match(/Trident\//)) {
        const rv = sAgent.indexOf('rv:');
        return parseInt(sAgent.substring(rv + 3, sAgent.indexOf('.', rv)), 10);
      }

      // If EDGE IE 12+
      else if (sAgent.match(/Edge\//)) {
        const edge = sAgent.indexOf('Edge/');
        return parseInt(sAgent.substring(edge + 5, sAgent.indexOf('.', edge)), 10);
      }

      else {
        return 0; //It is not IE
      }
    }
  }
})();
